
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12880',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12880",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9825",
  "foundations-components": "static-1.8261",
  "foundations-components-legacy": "static-1.1286",
  "foundations-theming": "static-1.4604",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.84",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8187",
  "hub-http-shared-msw-handlers": "static-1.10383",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11642",
  "I18n": "static-7.1644",
  "jasmine-runner": "static-1.6622",
  "marketplace-discovery-studio-lib": "static-1.402",
  "marketplace-storefront-base": "static-1.12943",
  "quartz": "static-1.7247",
  "react-dlb": "static-1.83",
  "react-rhumb": "static-1.16866",
  "reactive-variable-buffer-atom": "static-1.3023",
  "reporting-testing-lib": "static-1.10156",
  "reselect": "static-3.7",
  "settings-ui-lib": "static-1.12685",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7441",
  "ui-addon-i18n": "static-1.11315",
  "ui-addon-react-router-dom": "static-1.9700",
  "unified-auth": "static-1.689",
  "unified-auth-core-lib": "static-1.971",
  "usage-tracker": "static-1.7518",
  "usage-tracker-core": "static-1.7368",
  "customer-data-property-utils": "static-1.8262",
  "hub-http": "static-1.6386",
  "integrations-lib": "static-1.16703",
  "marketplace-ui-common": "static-1.20317",
  "property-management-iframe": "static-1.13743",
  "quartz-config": "static-1.1025",
  "quartz-core": "static-1.6466",
  "quartz-routing": "static-1.677",
  "quick-fetch": "static-1.4036",
  "react": "static-7.189",
  "rpc-client-utils": "static-1.4824",
  "ts-schema": "static-1.4201",
  "ui-universal-auth": "static-1.9175",
  "UIComponents": "static-3.8588",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3520",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3524",
  "quartz-webpack": "static-1.3471",
  "bend-plugin-quartz-routing": "static-1.325",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4530",
  "floating-ui": "static-1.59",
  "foundations-assets": "static-1.5040",
  "foundations-theming-specialty": "static-1.2320",
  "framer-motion": "static-1.74",
  "hs-story-utils": "static-1.9590",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.43",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5461",
  "react-virtualized": "static-2.101",
  "StyleGuideUI": "static-3.490",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2267",
  "ui-fonts": "static-1.904",
  "ui-images": "static-2.1202",
  "bend-plugin-foundations-theming": "static-1.3087",
  "foundations-theming-base": "static-1.3589",
  "stylex": "static-1.36",
  "HeadJS": "static-2.776",
  "hs-test-utils-bend-plugin": "static-1.3298",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4490",
  "ui-addon-video-player": "static-1.8871",
  "ai-components-ui-library": "static-1.9384",
  "ai-rendering-library": "static-1.10772",
  "chirp-fetch": "static-1.2054",
  "connections-embed-lib": "static-1.1313",
  "copilot-toolkit": "static-1.11571",
  "feedback-loader": "static-1.29613",
  "laboratory-lib": "static-3.7318",
  "marketplace-embed": "static-1.22612",
  "marketplace-ui-details": "static-1.10212",
  "marketplace-ui-reviews": "static-1.20272",
  "marketplace-ui-tracking": "static-1.14487",
  "sanitize-text": "static-1.8312",
  "usage-tracker-multi": "static-1.5932",
  "usage-tracker-session-replay": "static-1.5204",
  "wootric-nps": "static-1.7104",
  "quartz-head": "static-1.912",
  "web-vitals": "static-1.8",
  "apollo-link-hub-http": "static-2.4817",
  "immer": "static-1.33",
  "immerable": "static-1.4317",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2599",
  "reporting-data": "static-1.68223",
  "cssUtils": "static-1.840",
  "flux-actions": "static-1.351",
  "HubStyle": "static-2.11949",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10374",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10530",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7508",
  "icons": "static-2.663",
  "marketplace-ui-apps-core": "static-1.18849",
  "storybook-react": "static-1.35",
  "trellis-story-utils": "static-1.4673",
  "foundations-components-test-utils": "static-1.5744",
  "quartz-i18n": "static-1.922",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.184",
  "ads-unified-auth-lib": "static-1.667",
  "google-sheets-integration-lib": "static-1.748",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.200",
  "slack-ui-library": "static-1.10563",
  "fsm": "static-1.3896",
  "customer-data-objects": "static-1.7845",
  "property-translator": "static-1.5561",
  "hs-locale-management": "static-1.201",
  "frontend-preferences-client": "static-1.8094",
  "hs-promise-utils": "static-1.5761",
  "hubspot-apollo-client": "static-1.5045",
  "integrations-error-boundary-lib": "static-1.14118",
  "integrations-tracking-lib": "static-1.5772",
  "native-integrations-shared-strings": "static-1.7946",
  "sanitize": "static-1.4643",
  "superstore": "static-1.4925",
  "ui-shepherd-react": "static-3.10428",
  "ai-settings-ui-library": "static-1.8147",
  "hub-http-janus": "static-1.851",
  "hubspotter-http": "static-1.4770",
  "immutable-less": "static-1.4816",
  "marketplace-ui-client-types": "static-1.17724",
  "nav-meta": "static-1.30111",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18212",
  "inbound-db-properties-service-client": "static-1.3966",
  "property-management-common": "static-1.6031",
  "ui-addon-iframeable": "static-1.9243",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.550",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.922",
  "quartz-test": "static-1.922",
  "quartz-tracking": "static-1.626",
  "trellis-components": "static-1.2286",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.234",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22155",
  "ContentUtils": "static-1.68870",
  "customer-data-objects-ui-components": "static-1.13196",
  "sassPrefix": "static-1.159",
  "avatar-components": "static-1.2666",
  "breeze-engine-core": "static-1.601",
  "breeze-onboarding-components": "static-1.420",
  "customer-data-filters-ui": "static-1.40429",
  "customer-data-reference-ui-components": "static-1.13342",
  "embedded-academy-lib": "static-1.14960",
  "ExportDialog": "static-6.10545",
  "highlight.js": "static-1.81",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41737",
  "reporting-snowflake": "static-1.56841",
  "reporting-ui-components": "static-2.65494",
  "reporting-visualizations": "static-1.60299",
  "trellis-theming": "static-1.1114",
  "ui-addon-teams": "static-1.21760",
  "integrations-reconnect-lib": "static-1.286",
  "magpie-lib": "static-1.5662",
  "navigation-components": "static-1.18474",
  "breeze-engine-lib": "static-1.1323",
  "magpie-types": "static-1.5122",
  "simple-logging-lib": "static-1.3216",
  "ai-studio-lib": "static-1.12120",
  "app-governance-lib": "static-1.2091",
  "developer-experience-shared-components": "static-1.10702",
  "hubspot-prosemirror": "static-1.18730",
  "purchase-motions-components": "static-1.6160",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8186",
  "ui-product-approvals": "static-1.28787",
  "ui-tool-access": "static-1.10319",
  "usage-based-billing-components-lib": "static-1.9661",
  "usage-tracker-anonymous": "static-1.5935",
  "usage-tracker-public": "static-1.7329",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3707",
  "persist-promise": "static-1.3867",
  "reference-resolvers": "static-1.8342",
  "ui-extensibility-client-types": "static-1.4090",
  "hubspot-apollo-cache": "static-1.504",
  "universal-page-editor-lib": "static-1.3178",
  "final-form": "static-1.72",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3265",
  "atom": "static-1.5241",
  "merchandise-lib": "static-1.266",
  "salesImages": "static-1.528",
  "batch-promise": "static-1.1710",
  "crm-component-utils": "static-1.39554",
  "crm-properties-common-lib": "static-1.6054",
  "customer-data-properties": "static-1.52150",
  "framework-data-schema-resolvers": "static-1.7061",
  "property-value-citations": "static-1.2764",
  "reference-resolvers-lite": "static-1.8263",
  "ui-business-units-lib": "static-1.9245",
  "navigation-messaging": "static-1.7801",
  "hubspotter-http-shared-msw-handlers": "static-1.10381",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "cms-field-types": "static-1.4981",
  "content-icons-ui": "static-1.2276",
  "customer-data-ui-utilities": "static-1.9990",
  "conversations-skeleton-state": "static-1.7414",
  "crm-message-bus": "static-1.43469",
  "customer-data-filters-ui-msw-helpers": "static-1.22864",
  "events-data-lib": "static-1.404",
  "FormUrlGenerator": "static-2.4887",
  "framework-builder-read-service-client": "static-1.4125",
  "framework-data-schema-quick-fetch": "static-1.6966",
  "multi-account-reference-resolvers": "static-1.1150",
  "onboarding-tours": "static-1.16922",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14175",
  "academy-common-lib": "static-1.14420",
  "content-assistance-lib": "static-1.8013",
  "dashboard-lib": "static-1.82205",
  "file-manager-components": "static-1.24123",
  "getting-started-shared-tasks": "static-1.18919",
  "hubspot-prosemirror-plugins": "static-1.18722",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20126",
  "share-with-third-party-component-lib": "static-1.8872",
  "ui-addon-draggable": "static-3.4924",
  "ui-asset-management-lib": "static-1.11248",
  "user-context": "static-1.5276",
  "growth-payments-core": "static-1.25896",
  "reporting-plugins": "static-1.10588",
  "reporting-reports": "static-1.67901",
  "idb-keyval": "static-1.46",
  "reactive-lib": "static-1.890",
  "nest": "static-1.400",
  "ably": "static-2.2",
  "codemirror": "static-5.97",
  "react-codemirror": "static-1.10797",
  "framework-listing-lib": "static-2.29191",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31100",
  "apps-service-types": "static-1.3967",
  "oauth-service-types": "static-1.4421",
  "content-media-capture": "static-1.5068",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8584",
  "payment-link-components": "static-1.23897",
  "ui-addon-emoji-picker": "static-1.10050",
  "video-components-external": "static-1.11843",
  "video-data-lib": "static-1.35501",
  "onboarding-scopes": "static-1.6626",
  "purchase-motions-api": "static-1.6163",
  "signup-constants": "static-1.19289",
  "signup-ui-url-generator": "static-2.8224",
  "react-dnd-compat": "static-1.4781",
  "ui-product-approvals-common": "static-1.682",
  "onboarding-tours-client": "static-1.5136",
  "platform-infra-nav-components": "static-1.7794",
  "subscription-experience-data-types": "static-1.15122",
  "crm-record-cards-service-types": "static-1.3704",
  "location-customization-utils-lib": "static-1.9760",
  "redux-thunk": "static-2.43",
  "card-properties-lib": "static-1.44722",
  "commerce-subscription-lib": "static-1.37579",
  "crm-actions": "static-1.6511",
  "crm-cards-sdk": "static-1.44118",
  "customer-data-properties-shared-msw-handlers": "static-1.9710",
  "customer-data-tracking": "static-1.7050",
  "hs-resources": "static-1.345",
  "pulse": "static-1.778",
  "calling-global-api": "static-1.65102",
  "calling-internal-common": "static-1.31479",
  "calling-lifecycle-internal": "static-1.66484",
  "calling-lifecycle-messages": "static-1.58778",
  "commerce-products-lib": "static-1.10197",
  "conditional-properties-service-client": "static-1.3917",
  "crm-links": "static-1.6481",
  "crm-pipelines-api-client-types": "static-1.4257",
  "external-options-client-types": "static-1.4246",
  "formula-editor": "static-1.14555",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4338",
  "meetings-icalendar-utils-lib": "static-1.799",
  "multi-currency-client-types": "static-1.3811",
  "object-builder-ui-client": "static-1.49304",
  "pipeline-validation-client-types": "static-1.4086",
  "smart-property-lib": "static-1.8046",
  "tiered-pricing": "static-1.1690",
  "topics-actions-lib": "static-1.305",
  "ui-addon-form-validation": "static-1.11157",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.180",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1348",
  "growth-data-modal": "static-1.5705",
  "growth-onboarding-confetti": "static-1.3231",
  "growth-onboarding-next-action-utils": "static-1.2423",
  "onboarding-tours-utils": "static-1.988",
  "ui-shepherd-tracker": "static-1.7809",
  "academy-service-client": "static-1.3851",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39622",
  "FileManagerLib": "static-1.39763",
  "SafeStorage": "static-1.4566",
  "video-embed": "static-1.36335",
  "ui-coaching-tips": "static-1.29041",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24748",
  "viral-links-lib": "static-1.7238",
  "data-token-picker": "static-1.16707",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.404",
  "timezone-utils": "static-2.5409",
  "seat-types-lib": "static-1.394",
  "getting-started-shared-tasks-store": "static-1.18037",
  "ui-addon-opt": "static-4.8527",
  "campaign-roi-lib": "static-1.9702",
  "ui-addon-calendars": "static-2.5488",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25794",
  "framework-data-table": "static-2.12305",
  "marketing-platform-lib": "static-1.7034",
  "nudge-client-utils": "static-1.2944",
  "nudge-custom-ui-functions": "static-1.1313",
  "switchboard-lib": "static-1.392",
  "app-users-service-client": "static-1.5783",
  "app-users-service-types": "static-1.5191",
  "mini-checkout-client": "static-1.27247",
  "onboarding-utils": "static-1.5527",
  "permissions-shared-i18n-strings-fe": "static-1.2073",
  "ui-coaching-tips-shared-config": "static-1.29026",
  "content-media-composition-data-lib": "static-1.12872",
  "fix-webm-duration": "static-1.25",
  "notification-sounds": "static-1.4591",
  "commerce-tours-lib": "static-1.6421",
  "growth-onboarding-reliability": "static-1.5249",
  "sales-checkout-service-client": "static-1.3741",
  "content-media-compositions": "static-2.16879",
  "media-bridge-lib": "static-1.19222",
  "edison-service-client-types": "static-1.553",
  "crm_data": "static-4.92500",
  "customer-data-sidebar": "static-2.46485",
  "enrichment-properties-lib": "static-1.17288",
  "ui-addon-draggable-compat": "static-2.4425",
  "universal-record-utils-lib": "static-1.1436",
  "commerce-billing-lib": "static-1.19660",
  "commerce-shared-components-lib": "static-1.18965",
  "commerce-tools-ui-lib": "static-1.10815",
  "crm-fe-perf": "static-1.23066",
  "event-emitter": "static-1.1116",
  "bend-plugin-pulse": "static-1.281",
  "fast-json-patch": "static-1.65",
  "calling-error-reporting": "static-1.31486",
  "shared-worker-versioning": "static-1.11202",
  "calling-usage-tracker": "static-1.6707",
  "voice-sms-access-library": "static-1.1615",
  "commerce-permissions": "static-1.942",
  "products-iframe-lib": "static-1.8345",
  "products-ui-components-shared-msw-handlers": "static-1.10765",
  "bark-lib": "static-1.16638",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10466",
  "policy-lib": "static-1.6951",
  "react-tinymce": "static-1.55703",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10529",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54829",
  "tinymce-plugins": "static-1.57943",
  "tinymce-themes": "static-1.56799",
  "onboarding-data-sync-lib": "static-1.2253",
  "growth-onboarding-next-action-components": "static-1.2451",
  "user-context-client": "static-1.4718",
  "audio-components": "static-1.6170",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37274",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4698",
  "video-components": "static-1.13845",
  "outpost": "static-1.4334",
  "growth-onboarding-feedback-components": "static-1.6745",
  "draft-convert": "static-2.75",
  "draft-extend": "static-3.78",
  "draft-js": "static-5.80",
  "draft-plugins": "static-2.21972",
  "sales-email-signature-service-client": "static-1.4014",
  "ts-utils-lib": "static-1.339",
  "crm-export-dialog": "static-1.6450",
  "crm-index-associations-lib": "static-1.6607",
  "crm-view-components": "static-1.802",
  "react-beautiful-dnd": "static-1.65",
  "customer-data-associations": "static-1.7498",
  "nudge-custom-function-registry": "static-1.2701",
  "nudge-renderer-utils": "static-1.3020",
  "whisper-core-api": "static-1.7040",
  "InboxConnectUtils": "static-4.15276",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5958",
  "settings-content-modals": "static-1.46571",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22311",
  "customer-data-email": "static-1.18345",
  "card-payment-highlight-lib": "static-1.37676",
  "card-subscription-highlight-lib": "static-1.40002",
  "commerce-contract-lib": "static-1.12862",
  "invoices-highlight-card-lib": "static-1.55289",
  "orders-highlight-card-lib": "static-1.21942",
  "products-highlight-card-lib": "static-1.18480",
  "quotes-highlight-card-lib": "static-1.72577",
  "crm-source-interpretation-lib": "static-1.5499",
  "crm-object-search-query-utilities": "static-1.9962",
  "utility-belt": "static-1.2699",
  "payments-enrollment-embed-lib": "static-1.23488",
  "stripe-embedded-components": "static-1.7811",
  "customer-data-rte": "static-1.33421",
  "cv-backend-services": "static-1.1584",
  "growth-onboarding-empty-states": "static-1.6068",
  "payments-post-enroll-local-storage-lib": "static-1.5272",
  "qrcode-generator": "static-1.71",
  "quotes-client-types": "static-1.38667",
  "trials-service-types": "static-1.4049",
  "calling-orchestration-schema": "static-1.36392",
  "sales-views-client-types": "static-1.4424",
  "react-reducer-toolkit": "static-1.16074",
  "hub-http-contrib": "static-1.3210",
  "interframe": "static-3.4922",
  "tinymce-data": "static-1.40914",
  "ui-addon-sales-email": "static-1.5378",
  "layout-dnd-components": "static-1.12772",
  "layout-dnd-utils": "static-1.11747",
  "ui-brand-identity-lib": "static-1.15901",
  "NamespacedHubStyle": "static-2.9174",
  "meetings-connect-utils-lib": "static-1.7773",
  "social-insights-client-types": "static-1.22527",
  "crm-index-visualization-core": "static-1.4352",
  "checkout-sdk": "static-3.24090",
  "company-details-components": "static-1.6365",
  "payment-method-components": "static-1.7021",
  "pricing-pages-ui-components": "static-1.14969",
  "quote-checkout-service-types": "static-1.3626",
  "upgrade-catalog-service-types": "static-1.3684",
  "access-control-lib": "static-1.10604",
  "EmailComponents": "static-1.55261",
  "EmailData": "static-1.53938",
  "redux-less": "static-2.9647",
  "sequences-lib": "static-1.8338",
  "ui-gdpr-components": "static-1.10516",
  "products-ui-components": "static-1.40715",
  "accounting-integrations-ui-components": "static-1.7344",
  "invoices-ui-lib": "static-1.55305",
  "commerce-products-api": "static-1.2541",
  "invoices-iframe-lib": "static-1.57363",
  "quotes-modal-lib": "static-1.103255",
  "quotes-ui-lib": "static-1.81298",
  "stripe-connect-js": "static-1.72",
  "draft-content-plugins": "static-1.28688",
  "ContentData": "static-1.68945",
  "layout-data-lib": "static-1.10072",
  "hub-http-rxjs": "static-1.817",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4102",
  "billing-payments-client-types": "static-1.4154",
  "react-performance-metrics-lib": "static-1.721",
  "pricing-pages-api": "static-1.14834",
  "ContentComponents": "static-2.71826",
  "marketing-contacts-lib": "static-1.10657",
  "marketing-email-service-types": "static-1.2026",
  "messaging-editing-lib": "static-1.46811",
  "messaging-usage-based-billing-components-lib": "static-1.1673",
  "automation-ui-source-apps": "static-1.19384",
  "automation-ui-types": "static-1.20302",
  "messaging-types-lib": "static-1.46548",
  "onboarding-settings-client": "static-1.4670",
  "sequences-client-types-lib": "static-1.8195",
  "commerce-tax-lib": "static-1.704",
  "price-books-api": "static-1.1414",
  "price-books-components": "static-1.1472",
  "property-description-translator": "static-1.4005",
  "ramp-editor": "static-1.624",
  "commerce-analytics-service-client": "static-1.3729",
  "totals-ui-components": "static-1.24056",
  "SalesContentIndexUI": "static-3.9479",
  "advanced-menus-core": "static-1.15409",
  "advanced-menus-lib": "static-1.12306",
  "ui-memberships-settings-lib": "static-1.34514",
  "segments-query-core": "static-1.1586",
  "automation-ui-ubb": "static-1.6218",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7503",
  "data-token-views": "static-1.16688",
  "forms-utils-lib": "static-1.12895",
  "payments-embed-points-lib": "static-1.13384",
  "simple-menus-core": "static-1.15408",
  "simple-menus-lib": "static-1.16925",
  "videoconference-integration-components": "static-1.7068",
  "marketing-contacts-client": "static-1.7674",
  "mc-hard-limits-client-types": "static-1.66",
  "automation-applications-service-types": "static-1.3623",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77593",
  "short-messages-app-service-client": "static-1.4085",
  "web-interactives-components": "static-1.14054",
  "web-interactives-data": "static-1.14055",
  "messaging-shared-utils-lib": "static-1.1122",
  "messaging-user-info-utils-lib": "static-1.1292",
  "email-portal-health-service-types": "static-1.1142",
  "line-items-api": "static-1.938",
  "commerce-totals-service-types": "static-1.3937",
  "FireAlarmUi": "static-1.4628",
  "sales-templates-service-types-lib": "static-1.4290",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22238",
  "automation-ui-usage-tracking": "static-1.21701",
  "data-studio-ubb": "static-1.3219",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27412",
  "collaboration-sidebar": "static-1.58388",
  "content-management-data-lib": "static-1.5736",
  "copilot-plugins": "static-1.11544",
  "cta-picker": "static-1.36838",
  "customer-agent-discovery-components-lib": "static-1.3560",
  "editor-components": "static-1.13474",
  "editor-iframe-lib": "static-1.8635",
  "error-messaging-js": "static-1.5362",
  "FormsCommonComponents": "static-1.86300",
  "pictos": "static-7.187",
  "react-transition-group": "static-2.67",
  "redux-request-state": "static-1.10813",
  "SharedLegalStrings": "static-1.1910",
  "smart-content-core": "static-1.42913",
  "smart-content-lib": "static-1.43566",
  "social-composer-lib": "static-1.59776",
  "structured-content-lib": "static-1.25656",
  "theme-previewer-lib": "static-1.53707",
  "tinymce-copilot": "static-1.16897",
  "xray-recommendation-lib": "static-1.8114",
  "automation-ui-routing": "static-1.21659",
  "sql-reporting-client-types": "static-1.5774",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42562",
  "campaigns-utils-lib": "static-1.3359",
  "reporting-enablement": "static-1.23495",
  "chatspot-widget-iframe": "static-1.22146",
  "collaboration-sidebar-common": "static-1.3185",
  "forms-ai-lib": "static-1.4579",
  "codemirror-dlb": "static-1.59152",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6601",
  "report-customization-components": "static-1.13623",
  "data-quality-ui-library": "static-1.13476",
  "reporting-filters": "static-1.747",
  "reporting-insights-lib": "static-1.2266"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12880",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9825",
  "foundations-components": "/foundations-components/static-1.8261",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1286",
  "foundations-theming": "/foundations-theming/static-1.4604",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.84",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8187",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10383",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11642",
  "I18n": "/I18n/static-7.1644",
  "jasmine-runner": "/jasmine-runner/static-1.6622",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.402",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12943",
  "quartz": "/quartz/static-1.7247",
  "react-dlb": "/react-dlb/static-1.83",
  "react-rhumb": "/react-rhumb/static-1.16866",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3023",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10156",
  "reselect": "/reselect/static-3.7",
  "settings-ui-lib": "/settings-ui-lib/static-1.12685",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7441",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11315",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9700",
  "unified-auth": "/unified-auth/static-1.689",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.971",
  "usage-tracker": "/usage-tracker/static-1.7518",
  "usage-tracker-core": "/usage-tracker-core/static-1.7368",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8262",
  "hub-http": "/hub-http/static-1.6386",
  "integrations-lib": "/integrations-lib/static-1.16703",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20317",
  "property-management-iframe": "/property-management-iframe/static-1.13743",
  "quartz-config": "/quartz-config/static-1.1025",
  "quartz-core": "/quartz-core/static-1.6466",
  "quartz-routing": "/quartz-routing/static-1.677",
  "quick-fetch": "/quick-fetch/static-1.4036",
  "react": "/react/static-7.189",
  "rpc-client-utils": "/rpc-client-utils/static-1.4824",
  "ts-schema": "/ts-schema/static-1.4201",
  "ui-universal-auth": "/ui-universal-auth/static-1.9175",
  "UIComponents": "/UIComponents/static-3.8588",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3520",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3524",
  "quartz-webpack": "/quartz-webpack/static-1.3471",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.325",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4530",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.5040",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2320",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-story-utils": "/hs-story-utils/static-1.9590",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.43",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5461",
  "react-virtualized": "/react-virtualized/static-2.101",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2267",
  "ui-fonts": "/ui-fonts/static-1.904",
  "ui-images": "/ui-images/static-2.1202",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3087",
  "foundations-theming-base": "/foundations-theming-base/static-1.3589",
  "stylex": "/stylex/static-1.36",
  "HeadJS": "/HeadJS/static-2.776",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3298",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4490",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8871",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9384",
  "ai-rendering-library": "/ai-rendering-library/static-1.10772",
  "chirp-fetch": "/chirp-fetch/static-1.2054",
  "connections-embed-lib": "/connections-embed-lib/static-1.1313",
  "copilot-toolkit": "/copilot-toolkit/static-1.11571",
  "feedback-loader": "/feedback-loader/static-1.29613",
  "laboratory-lib": "/laboratory-lib/static-3.7318",
  "marketplace-embed": "/marketplace-embed/static-1.22612",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10212",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20272",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14487",
  "sanitize-text": "/sanitize-text/static-1.8312",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5932",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5204",
  "wootric-nps": "/wootric-nps/static-1.7104",
  "quartz-head": "/quartz-head/static-1.912",
  "web-vitals": "/web-vitals/static-1.8",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4817",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4317",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2599",
  "reporting-data": "/reporting-data/static-1.68223",
  "cssUtils": "/cssUtils/static-1.840",
  "flux-actions": "/flux-actions/static-1.351",
  "HubStyle": "/HubStyle/static-2.11949",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10374",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10530",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7508",
  "icons": "/icons/static-2.663",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18849",
  "storybook-react": "/storybook-react/static-1.35",
  "trellis-story-utils": "/trellis-story-utils/static-1.4673",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5744",
  "quartz-i18n": "/quartz-i18n/static-1.922",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.184",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.667",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.748",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.200",
  "slack-ui-library": "/slack-ui-library/static-1.10563",
  "fsm": "/fsm/static-1.3896",
  "customer-data-objects": "/customer-data-objects/static-1.7845",
  "property-translator": "/property-translator/static-1.5561",
  "hs-locale-management": "/hs-locale-management/static-1.201",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8094",
  "hs-promise-utils": "/hs-promise-utils/static-1.5761",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5045",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14118",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5772",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7946",
  "sanitize": "/sanitize/static-1.4643",
  "superstore": "/superstore/static-1.4925",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10428",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8147",
  "hub-http-janus": "/hub-http-janus/static-1.851",
  "hubspotter-http": "/hubspotter-http/static-1.4770",
  "immutable-less": "/immutable-less/static-1.4816",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17724",
  "nav-meta": "/nav-meta/static-1.30111",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18212",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3966",
  "property-management-common": "/property-management-common/static-1.6031",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9243",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.550",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.922",
  "quartz-test": "/quartz-test/static-1.922",
  "quartz-tracking": "/quartz-tracking/static-1.626",
  "trellis-components": "/trellis-components/static-1.2286",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.234",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22155",
  "ContentUtils": "/ContentUtils/static-1.68870",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13196",
  "sassPrefix": "/sassPrefix/static-1.159",
  "avatar-components": "/avatar-components/static-1.2666",
  "breeze-engine-core": "/breeze-engine-core/static-1.601",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.420",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40429",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13342",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14960",
  "ExportDialog": "/ExportDialog/static-6.10545",
  "highlight.js": "/highlight.js/static-1.81",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41737",
  "reporting-snowflake": "/reporting-snowflake/static-1.56841",
  "reporting-ui-components": "/reporting-ui-components/static-2.65494",
  "reporting-visualizations": "/reporting-visualizations/static-1.60299",
  "trellis-theming": "/trellis-theming/static-1.1114",
  "ui-addon-teams": "/ui-addon-teams/static-1.21760",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.286",
  "magpie-lib": "/magpie-lib/static-1.5662",
  "navigation-components": "/navigation-components/static-1.18474",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1323",
  "magpie-types": "/magpie-types/static-1.5122",
  "simple-logging-lib": "/simple-logging-lib/static-1.3216",
  "ai-studio-lib": "/ai-studio-lib/static-1.12120",
  "app-governance-lib": "/app-governance-lib/static-1.2091",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10702",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18730",
  "purchase-motions-components": "/purchase-motions-components/static-1.6160",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8186",
  "ui-product-approvals": "/ui-product-approvals/static-1.28787",
  "ui-tool-access": "/ui-tool-access/static-1.10319",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9661",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5935",
  "usage-tracker-public": "/usage-tracker-public/static-1.7329",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3707",
  "persist-promise": "/persist-promise/static-1.3867",
  "reference-resolvers": "/reference-resolvers/static-1.8342",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4090",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.504",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3178",
  "final-form": "/final-form/static-1.72",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3265",
  "atom": "/atom/static-1.5241",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "salesImages": "/salesImages/static-1.528",
  "batch-promise": "/batch-promise/static-1.1710",
  "crm-component-utils": "/crm-component-utils/static-1.39554",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6054",
  "customer-data-properties": "/customer-data-properties/static-1.52150",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7061",
  "property-value-citations": "/property-value-citations/static-1.2764",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8263",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9245",
  "navigation-messaging": "/navigation-messaging/static-1.7801",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10381",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "cms-field-types": "/cms-field-types/static-1.4981",
  "content-icons-ui": "/content-icons-ui/static-1.2276",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9990",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7414",
  "crm-message-bus": "/crm-message-bus/static-1.43469",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22864",
  "events-data-lib": "/events-data-lib/static-1.404",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4887",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4125",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6966",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1150",
  "onboarding-tours": "/onboarding-tours/static-1.16922",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14175",
  "academy-common-lib": "/academy-common-lib/static-1.14420",
  "content-assistance-lib": "/content-assistance-lib/static-1.8013",
  "dashboard-lib": "/dashboard-lib/static-1.82205",
  "file-manager-components": "/file-manager-components/static-1.24123",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18919",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18722",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20126",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8872",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4924",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11248",
  "user-context": "/user-context/static-1.5276",
  "growth-payments-core": "/growth-payments-core/static-1.25896",
  "reporting-plugins": "/reporting-plugins/static-1.10588",
  "reporting-reports": "/reporting-reports/static-1.67901",
  "idb-keyval": "/idb-keyval/static-1.46",
  "reactive-lib": "/reactive-lib/static-1.890",
  "nest": "/nest/static-1.400",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.97",
  "react-codemirror": "/react-codemirror/static-1.10797",
  "framework-listing-lib": "/framework-listing-lib/static-2.29191",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31100",
  "apps-service-types": "/apps-service-types/static-1.3967",
  "oauth-service-types": "/oauth-service-types/static-1.4421",
  "content-media-capture": "/content-media-capture/static-1.5068",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "payment-link-components": "/payment-link-components/static-1.23897",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10050",
  "video-components-external": "/video-components-external/static-1.11843",
  "video-data-lib": "/video-data-lib/static-1.35501",
  "onboarding-scopes": "/onboarding-scopes/static-1.6626",
  "purchase-motions-api": "/purchase-motions-api/static-1.6163",
  "signup-constants": "/signup-constants/static-1.19289",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8224",
  "react-dnd-compat": "/react-dnd-compat/static-1.4781",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.682",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5136",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7794",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15122",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3704",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9760",
  "redux-thunk": "/redux-thunk/static-2.43",
  "card-properties-lib": "/card-properties-lib/static-1.44722",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37579",
  "crm-actions": "/crm-actions/static-1.6511",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44118",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9710",
  "customer-data-tracking": "/customer-data-tracking/static-1.7050",
  "hs-resources": "/hs-resources/static-1.345",
  "pulse": "/pulse/static-1.778",
  "calling-global-api": "/calling-global-api/static-1.65102",
  "calling-internal-common": "/calling-internal-common/static-1.31479",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66484",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58778",
  "commerce-products-lib": "/commerce-products-lib/static-1.10197",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3917",
  "crm-links": "/crm-links/static-1.6481",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4257",
  "external-options-client-types": "/external-options-client-types/static-1.4246",
  "formula-editor": "/formula-editor/static-1.14555",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4338",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.799",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3811",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49304",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4086",
  "smart-property-lib": "/smart-property-lib/static-1.8046",
  "tiered-pricing": "/tiered-pricing/static-1.1690",
  "topics-actions-lib": "/topics-actions-lib/static-1.305",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11157",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.180",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1348",
  "growth-data-modal": "/growth-data-modal/static-1.5705",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3231",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2423",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.988",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7809",
  "academy-service-client": "/academy-service-client/static-1.3851",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39622",
  "FileManagerLib": "/FileManagerLib/static-1.39763",
  "SafeStorage": "/SafeStorage/static-1.4566",
  "video-embed": "/video-embed/static-1.36335",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29041",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24748",
  "viral-links-lib": "/viral-links-lib/static-1.7238",
  "data-token-picker": "/data-token-picker/static-1.16707",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.404",
  "timezone-utils": "/timezone-utils/static-2.5409",
  "seat-types-lib": "/seat-types-lib/static-1.394",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18037",
  "ui-addon-opt": "/ui-addon-opt/static-4.8527",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9702",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5488",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25794",
  "framework-data-table": "/framework-data-table/static-2.12305",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7034",
  "nudge-client-utils": "/nudge-client-utils/static-1.2944",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1313",
  "switchboard-lib": "/switchboard-lib/static-1.392",
  "app-users-service-client": "/app-users-service-client/static-1.5783",
  "app-users-service-types": "/app-users-service-types/static-1.5191",
  "mini-checkout-client": "/mini-checkout-client/static-1.27247",
  "onboarding-utils": "/onboarding-utils/static-1.5527",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2073",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29026",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12872",
  "fix-webm-duration": "/fix-webm-duration/static-1.25",
  "notification-sounds": "/notification-sounds/static-1.4591",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6421",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5249",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3741",
  "content-media-compositions": "/content-media-compositions/static-2.16879",
  "media-bridge-lib": "/media-bridge-lib/static-1.19222",
  "edison-service-client-types": "/edison-service-client-types/static-1.553",
  "crm_data": "/crm_data/static-4.92500",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46485",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17288",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4425",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1436",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19660",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18965",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10815",
  "crm-fe-perf": "/crm-fe-perf/static-1.23066",
  "event-emitter": "/event-emitter/static-1.1116",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.281",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "calling-error-reporting": "/calling-error-reporting/static-1.31486",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11202",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6707",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1615",
  "commerce-permissions": "/commerce-permissions/static-1.942",
  "products-iframe-lib": "/products-iframe-lib/static-1.8345",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10765",
  "bark-lib": "/bark-lib/static-1.16638",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10466",
  "policy-lib": "/policy-lib/static-1.6951",
  "react-tinymce": "/react-tinymce/static-1.55703",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10529",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54829",
  "tinymce-plugins": "/tinymce-plugins/static-1.57943",
  "tinymce-themes": "/tinymce-themes/static-1.56799",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2253",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2451",
  "user-context-client": "/user-context-client/static-1.4718",
  "audio-components": "/audio-components/static-1.6170",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37274",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4698",
  "video-components": "/video-components/static-1.13845",
  "outpost": "/outpost/static-1.4334",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6745",
  "draft-convert": "/draft-convert/static-2.75",
  "draft-extend": "/draft-extend/static-3.78",
  "draft-js": "/draft-js/static-5.80",
  "draft-plugins": "/draft-plugins/static-2.21972",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4014",
  "ts-utils-lib": "/ts-utils-lib/static-1.339",
  "crm-export-dialog": "/crm-export-dialog/static-1.6450",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6607",
  "crm-view-components": "/crm-view-components/static-1.802",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.65",
  "customer-data-associations": "/customer-data-associations/static-1.7498",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2701",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3020",
  "whisper-core-api": "/whisper-core-api/static-1.7040",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15276",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5958",
  "settings-content-modals": "/settings-content-modals/static-1.46571",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22311",
  "customer-data-email": "/customer-data-email/static-1.18345",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37676",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40002",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12862",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55289",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21942",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18480",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72577",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5499",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9962",
  "utility-belt": "/utility-belt/static-1.2699",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23488",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7811",
  "customer-data-rte": "/customer-data-rte/static-1.33421",
  "cv-backend-services": "/cv-backend-services/static-1.1584",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6068",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5272",
  "qrcode-generator": "/qrcode-generator/static-1.71",
  "quotes-client-types": "/quotes-client-types/static-1.38667",
  "trials-service-types": "/trials-service-types/static-1.4049",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36392",
  "sales-views-client-types": "/sales-views-client-types/static-1.4424",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16074",
  "hub-http-contrib": "/hub-http-contrib/static-1.3210",
  "interframe": "/interframe/static-3.4922",
  "tinymce-data": "/tinymce-data/static-1.40914",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5378",
  "layout-dnd-components": "/layout-dnd-components/static-1.12772",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11747",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15901",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9174",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7773",
  "social-insights-client-types": "/social-insights-client-types/static-1.22527",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4352",
  "checkout-sdk": "/checkout-sdk/static-3.24090",
  "company-details-components": "/company-details-components/static-1.6365",
  "payment-method-components": "/payment-method-components/static-1.7021",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14969",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3626",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3684",
  "access-control-lib": "/access-control-lib/static-1.10604",
  "EmailComponents": "/EmailComponents/static-1.55261",
  "EmailData": "/EmailData/static-1.53938",
  "redux-less": "/redux-less/static-2.9647",
  "sequences-lib": "/sequences-lib/static-1.8338",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10516",
  "products-ui-components": "/products-ui-components/static-1.40715",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7344",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55305",
  "commerce-products-api": "/commerce-products-api/static-1.2541",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57363",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103255",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81298",
  "stripe-connect-js": "/stripe-connect-js/static-1.72",
  "draft-content-plugins": "/draft-content-plugins/static-1.28688",
  "ContentData": "/ContentData/static-1.68945",
  "layout-data-lib": "/layout-data-lib/static-1.10072",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.817",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4102",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4154",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.721",
  "pricing-pages-api": "/pricing-pages-api/static-1.14834",
  "ContentComponents": "/ContentComponents/static-2.71826",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10657",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2026",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46811",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1673",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19384",
  "automation-ui-types": "/automation-ui-types/static-1.20302",
  "messaging-types-lib": "/messaging-types-lib/static-1.46548",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4670",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8195",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.704",
  "price-books-api": "/price-books-api/static-1.1414",
  "price-books-components": "/price-books-components/static-1.1472",
  "property-description-translator": "/property-description-translator/static-1.4005",
  "ramp-editor": "/ramp-editor/static-1.624",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3729",
  "totals-ui-components": "/totals-ui-components/static-1.24056",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9479",
  "advanced-menus-core": "/advanced-menus-core/static-1.15409",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12306",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34514",
  "segments-query-core": "/segments-query-core/static-1.1586",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6218",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7503",
  "data-token-views": "/data-token-views/static-1.16688",
  "forms-utils-lib": "/forms-utils-lib/static-1.12895",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13384",
  "simple-menus-core": "/simple-menus-core/static-1.15408",
  "simple-menus-lib": "/simple-menus-lib/static-1.16925",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7068",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7674",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.66",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3623",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77593",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4085",
  "web-interactives-components": "/web-interactives-components/static-1.14054",
  "web-interactives-data": "/web-interactives-data/static-1.14055",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1122",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1292",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1142",
  "line-items-api": "/line-items-api/static-1.938",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3937",
  "FireAlarmUi": "/FireAlarmUi/static-1.4628",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4290",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22238",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21701",
  "data-studio-ubb": "/data-studio-ubb/static-1.3219",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27412",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58388",
  "content-management-data-lib": "/content-management-data-lib/static-1.5736",
  "copilot-plugins": "/copilot-plugins/static-1.11544",
  "cta-picker": "/cta-picker/static-1.36838",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3560",
  "editor-components": "/editor-components/static-1.13474",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8635",
  "error-messaging-js": "/error-messaging-js/static-1.5362",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86300",
  "pictos": "/pictos/static-7.187",
  "react-transition-group": "/react-transition-group/static-2.67",
  "redux-request-state": "/redux-request-state/static-1.10813",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1910",
  "smart-content-core": "/smart-content-core/static-1.42913",
  "smart-content-lib": "/smart-content-lib/static-1.43566",
  "social-composer-lib": "/social-composer-lib/static-1.59776",
  "structured-content-lib": "/structured-content-lib/static-1.25656",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53707",
  "tinymce-copilot": "/tinymce-copilot/static-1.16897",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8114",
  "automation-ui-routing": "/automation-ui-routing/static-1.21659",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5774",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42562",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3359",
  "reporting-enablement": "/reporting-enablement/static-1.23495",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22146",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3185",
  "forms-ai-lib": "/forms-ai-lib/static-1.4579",
  "codemirror-dlb": "/codemirror-dlb/static-1.59152",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6601",
  "report-customization-components": "/report-customization-components/static-1.13623",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13476",
  "reporting-filters": "/reporting-filters/static-1.747",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2266"
}
};
